import { Component, EventEmitter, OnInit, Output, HostListener, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ChatStateService } from 'src/app/services/chat-state.service';
import { RouterService } from 'src/app/services/router.service';
// import { CoreaiService } from 'src/app/services/coreai.service';

@Component({
  selector: 'app-prompt-list',
  templateUrl: './prompt-list.component.html',
  styleUrls: ['./prompt-list.component.scss']
})
export class PromptListComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<void>();
  @ViewChild('content') private contentRef!: TemplateRef<any>;

  private isSmallScreen: boolean = window.innerWidth < 768;
  isPromptListOpen: boolean = false;
  promptList: any = [];
  private modalReference: any;

  myRouterSub!: Subscription;
  currentRoute: any;
  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    // private coreAIService:CoreaiService,
    private chatStateService: ChatStateService,
    private routerService: RouterService
  ) {
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
  
    this.checkDatalabsRoute();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.modalIsOpen()) {
      this.modalService.dismissAll();
      this.openModal(this.contentRef);
    }
  }

  getPromptList() {

    let datalabsPromptList = [
      {
        id: 1,
        title: 'Plot a bar graph',
        prompt: 'Plot a bar graph to illustrate the relationship between [ColA] and [ColB]',
        icon: `prompt.svg`
      },
      {
        id: 2,
        title: 'Plot a pie chart',
        prompt: 'Plot a pie chart to illustrate the relationship between [ColA] and [ColB]',
        icon: `prompt.svg`
      },
      {
        id: 3,
        title: 'Summarise the content',
        prompt: 'Summarise the content of the file, highlighting the key points and main themes, and provide detailed insights and analysis based on the data or information presented.',
        icon: `prompt.svg`
      },
      {
        id: 4,
        title: 'Insights into data',
        prompt: 'Provide me insights from this data',
        icon: `prompt.svg`
      },
      {
        id: 5,
        title: 'Average of column',
        prompt: 'Provide me average of column [ColA]',
        icon: `prompt.svg`
      },
      {
        id: 6,
        title: 'Sum of column',
        prompt: 'Provide me sum of column [ColA]',
        icon: `prompt.svg`
      },
      {
        id: 7,
        title: 'Max and Min of column',
        prompt: 'Provide me minimum and maximum values from column [ColA]',
        icon: `prompt.svg`
      },
    ]

    let gptPromptList = [
      { id: 1, title: 'Slogan Crafting', prompt: 'Develop a catchy slogan that encapsulates our Genpact\'s culture and values. ', icon: `prompt.svg` },
      {
        id: 2,
        title: 'Neuro Ninja',
        prompt: 'Craft a concise puzzle challenging logic, memory, and creativity.',
        icon: `prompt.svg`
      },
      {
        id: 3,
        title: 'Team Collaboration',
        prompt: 'Develop strategies for positive workplace communication. ',
        icon: `prompt.svg`
      },
      { id: 4, title: 'Future Workspace', prompt: 'Describe the ideal future office layout, technology, and amenities for optimal productivity.', icon: `prompt.svg` },

      {
        id: 5,
        title: 'Travel Tips',
        prompt: 'Give me an itinerary for a 7-day visit to [country]',
        icon: `prompt.svg`
      },
      {
        id: 6,
        title: 'Policy Development',
        prompt: 'Create a [policy name] policy that addresses [specific issue].',
        icon: `prompt.svg`
      },
      {
        id: 7,
        title: 'Productivity Metrics',
        prompt: 'Suggest an innovative way to measure and track individual productivity.',
        icon: `prompt.svg`
      },
      { id: 8, title: 'Operational Streamlining', prompt: 'How could we use AI to streamline our operations and improve efficiency? ', icon: `prompt.svg` },

    ]

    if (this.currentRoute == 'datalabs') {
      this.promptList = datalabsPromptList;
    } else {
      this.promptList = gptPromptList;
    }
  };

  sentToInput(prompt: string) {
    this.chatStateService.promptInputState.next(prompt);
    this.closeModal();
  }


  getModalOptions(): NgbModalOptions {
    const windowWidth = window.innerWidth;
    console.log("Now Window Width is ", windowWidth);
    if (windowWidth < 768) { // You can adjust this breakpoint
      return { fullscreen: true, scrollable: true };
    } else {
      return { size: 'lg', scrollable: true, centered: true };
    }
  }

  private modalIsOpen(): boolean {
    return this.isPromptListOpen;
  }



  openModal(content: any) {
    this.isSmallScreen = window.innerWidth < 768;
    this.modalReference = this.modalService.open(content, {
      size: 'lg',
      backdrop: false,
      scrollable: true,
      centered: true,
      fullscreen: true
      /*fullscreen: this.isSmallScreen ? true : false*/
    });
    this.isPromptListOpen = true;
  }

  closeModal() {
    this.isPromptListOpen = false;
    this.modalReference.dismiss();
  }


  getIconPath(iconName: string): string {
    return `/assets/images/icons/${iconName}`;
  }

  // get router and manage file upload condition 
  checkDatalabsRoute(): void {
    this.myRouterSub = this.routerService.currentRoute.subscribe((res: any) => {
      const activeRoute = res.url;
      if (activeRoute.includes('/datalabs')) {
        this.currentRoute = 'datalabs';
      } else {
        this.currentRoute = '';
      }

      this.getPromptList();
    })
  }


  ngOnDestroy(): void {
    this.myRouterSub?.unsubscribe();
  }
}
